/**
 * External dependencies
 */
import classnames from "classnames";
import { isEmpty } from "lodash";

/**
 * WordPress dependencies
 */
import { __ } from "@wordpress/i18n";
import { Icon, blockDefault } from "@wordpress/icons";
import { Button } from "@wordpress/components";
import { useMemo } from "@wordpress/element";

export default function IconList(props) {
  const { icon, shownIcons, updateIconAtts } = props;

  const noResults = (
    <div className="block-editor-inserter__no-results">
      <Icon
        icon={blockDefault}
        className="block-editor-inserter__no-results-icon"
      />
      <p>{__("No results found.")}</p>
    </div>
  );

  const searchResults = (
    <div className="icons-list">
      {shownIcons.map(function (key) {
        return (
          <Button
            key={`icon-${key}`}
            className={classnames(
              "icons-list__item",
              "block-editor-block-types-list__item",
              {
                "is-active": key === icon?.name,
              }
            )}
            onClick={() => updateIconAtts(key)}
          >
            <span className="icons-list__item-icon">
              <i
                className={`ph${
                  icon?.type !== undefined && icon?.type !== "regular"
                    ? "-" + icon?.type
                    : ""
                } ph-${key}`}
              ></i>
            </span>
            <span className="icons-list__item-title">{key}</span>
          </Button>
        );
      })}
    </div>
  );

  return (
    <div className="icon-inserter__content-grid">
      {isEmpty(shownIcons) ? noResults : searchResults}
    </div>
  );
}
